import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { WELCOME_PATH } from "../../../../constants/env";
import { useIsLogged } from "../../../../hooks/auth/use-is-logged/use-is-logged";

interface AuthGuardWrapperProps {
  readonly children: ReactNode;
  readonly redirectTo?: string;
}

export function AuthGuardWrapper(props: AuthGuardWrapperProps): JSX.Element {
  const { children, redirectTo = WELCOME_PATH } = props;
  const isLogged = useIsLogged();

  if (!isLogged) {
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
}
